var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_124_185)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.966287 0.665789C0.745235 0.444737 0.38684 0.444737 0.165789 0.665789C-0.055263 0.88684 -0.055263 1.24523 0.165789 1.46629L5.1995 6.5L0.165789 11.5337C-0.055263 11.7548 -0.055263 12.1132 0.165789 12.3342C0.38684 12.5553 0.745235 12.5553 0.966287 12.3342L6 7.3005L11.0337 12.3342C11.2548 12.5553 11.6132 12.5553 11.8342 12.3342C12.0553 12.1132 12.0553 11.7548 11.8342 11.5337L6.8005 6.5L11.8342 1.46629C12.0553 1.24523 12.0553 0.88684 11.8342 0.665789C11.6132 0.444737 11.2548 0.444737 11.0337 0.665789L6 5.6995L0.966287 0.665789Z",
    fill: "#999896"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_124_185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.32cb809e6e972ae639f08de635ee28fd.svg";
export { ForwardRef as ReactComponent };